import Swal from "sweetalert2";
import { GET, POST } from "../../../../services/api";
import { AggregatorClassification } from "../../AggregadorCategory/aggregadorCategory.type";
import { LojaAgregador } from "../../lojas/type";
import { DinamicPageCreate, TypeDinamicGrid } from "../dinamyc-pages.types";
import uuid from 'react-uuid'
import { i18n } from "../../../../translate/i18n";

export function validateForm(form: DinamicPageCreate): Boolean {
    try {
        if (!form.title || form.title.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro',
                text: 'O título é obrigatório.',
            })

            return false
        }

        if (!form.description || form.description.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro',
                text: 'A descrição é obrigatória.',
            })

            return false
        }
        if (!form.aggregatorClassificationId) {
            Swal.fire({
                icon: 'warning',
                title: 'Erro',
                text: 'A classificação é obrigatória.',
            })
            return false
        }

        if (!form.storeId) {
            Swal.fire({
                icon: 'warning',
                title: 'Erro',
                text: 'A loja é obrigatória.',
            })
            return false
        }
        // validar agora se existe pelo menos um grid
        if (!form.grids || form.grids.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Erro',
                text: 'É necessário adicionar pelo menos um grid.',
            })
            return false
        }
        // validar todos os grids 
        for (const grid of form.grids) {
            if (grid.type === 'image') {
                if (!grid.configuration.image) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Erro',
                        text: 'O grid (' + grid.order + ') de imagem precisa ter uma imagem.',
                    })
                    return false
                }
            } else if (grid.type === 'carousel') {
                if (!grid.configuration.images || grid.configuration.images.length === 0) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Erro',
                        text: 'O grid (' + grid.order + ') de carrossel precisa ter pelo menos uma imagem.',
                    })
                    return false
                }
            } else if (grid.type === 'text') {
                if (!grid.configuration.text || grid.configuration.text.trim() === '') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Erro',
                        text: 'O grid (' + grid.order + ') de texto precisa ter um texto.',
                    })
                    return false
                }
            } else if (grid.type === 'content') {
                if (!grid.configuration.title || grid.configuration.title.trim() === '') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Erro',
                        text: 'O grid (' + grid.order + ') de conteúdo precisa ter um título.',
                    })
                    return false
                }
                if (!grid.configuration.text || grid.configuration.text.trim() === '') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Erro',
                        text: 'O grid (' + grid.order + ') de conteúdo precisa ter um texto.',
                    })
                    return false
                }
            }
        }

        if (!form.order) {
            Swal.fire({
                icon: 'warning',
                title: 'Erro',
                text: 'É necessário inserir uma ordenação válida.',
            })
            return false
        }

        if (!form.slug || form.slug.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro',
                text: 'É necessário inserir slug.',
            })
            return false
        }

        if (!form.seoTitle || form.seoTitle.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro',
                text: 'É necessário inserir seoTitle válido.',
            })
            return false
        }

        if (!form.seoDescription || form.seoDescription.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro',
                text: 'É necessário inserir seoDescription válido.',
            })
            return false
        }

        if (!form.shareImage) {
            Swal.fire({
                icon: 'warning',
                title: 'Erro',
                text: 'É necessário inserir uma imagem válida.',
            })
            return false
        }
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}

export async function getAgregadorStores(): Promise<LojaAgregador[]> {
    try {

        const query = `?field=id&order=ASC&page=0&take=5000&search=`

        const request = await GET(`pluginspaceaggregator${query}`)

        return request.data
    } catch (error) {
        return []
    }

}


export async function getAgregadorClassification(): Promise<AggregatorClassification[]> {
    try {
        const currentPage = 0
        const currentPageSize = 5000
        const currentSearch = ''
        const currentSorting = 'ASC'

        const query = `?field=id&order=${currentSorting}&page=${currentPage}&take=${currentPageSize}&search=${currentSearch}`

        const request = await GET(`aggregator-classification/subcategory${query}`)

        return request.data
    } catch (error) {
        return []
    }

}

interface SaveImageResult {
    success: boolean
    url: string
    error?: string
}



async function saveImage(
    image: string | File,
    name: string,
    retries: number = 3
): Promise<SaveImageResult> {
    for (let attempt = 1; attempt <= retries; attempt++) {
        try {
            // Se já for uma URL, não precisa fazer upload
            if (typeof image === 'string') {
                return {
                    success: true,
                    url: image,
                }
            }

            const formData = new FormData()

            formData.append('file', image)
            formData.append(
                'nameImage',
                `store-${name}-${uuid()}.jpg`
            )
            formData.append('originalSize', 'true')

            const imageRes = await POST('/upload-images/upload-one', formData)

            if (imageRes.success) {
                return {
                    success: true,
                    url: imageRes.image,
                }
            }

            if (attempt === retries) {
                return {
                    success: false,
                    url: '',
                    error: 'Resposta do servidor indicou falha',
                }
            }

        } catch (error) {
            if (attempt === retries) {
                return {
                    success: false,
                    url: '',
                    error: `Falha ao enviar imagem "${name}" após ${retries} tentativas`,
                }
            }

            // Aguarda antes de tentar novamente
            await new Promise(resolve =>
                setTimeout(resolve, 500 * attempt)
            )
        }
    }

    return {
        success: false,
        url: '',
        error: `Falha ao enviar imagem "${name}"`,
    }
}


export async function uploadImagesInForm(
    form: DinamicPageCreate
): Promise<{
    success: boolean
    form: DinamicPageCreate
    errors: string[]
}> {

    const uploadErrors: string[] = []

    try {
        const formToSend = form

        // ==========================================
        // IMAGEM PRINCIPAL
        // ==========================================

        if (
            formToSend.shareImage &&
            formToSend.shareImage instanceof File
        ) {
            const mainImageResult = await saveImage(
                formToSend.shareImage,
                formToSend.title
            )

            if (!mainImageResult.success) {
                uploadErrors.push(
                    `Imagem principal: ${mainImageResult.error}`
                )

                formToSend.shareImage = ''
            } else {
                formToSend.shareImage = mainImageResult.url
            }
        }


        // ==========================================
        // GRIDS
        // ==========================================

        for (const [gridIndex, grid] of formToSend.grids.entries()) {

            // ======================================
            // GRID DE IMAGEM
            // ======================================

            if (grid.type === TypeDinamicGrid.image) {
                const image = grid.configuration.image
                if (image instanceof File) {
                    const gridImageResult = await saveImage(image, `${formToSend.title}_grid(${gridIndex + 1})_${grid.type}`)
                    if (!gridImageResult.success) {
                        uploadErrors.push(`Grid ${gridIndex + 1} - imagem: ${gridImageResult.error}`)
                        grid.configuration.image = ''
                    } else {
                        grid.configuration.image = gridImageResult.url
                    }
                }
            }

            if (grid.type === TypeDinamicGrid.hero) {
                const image = grid.configuration.image
                if (image instanceof File) {
                    const gridImageResult = await saveImage(image, `${formToSend.title}_grid(${gridIndex + 1})_${grid.type}`)
                    if (!gridImageResult.success) {
                        uploadErrors.push(`Grid ${gridIndex + 1} - imagem: ${gridImageResult.error}`)
                        grid.configuration.image = ''
                    } else {
                        grid.configuration.image = gridImageResult.url
                    }
                }
            }


            // ======================================
            // GRID CAROUSEL
            // ======================================

            if (grid.type === TypeDinamicGrid.carousel) {
                const imagesCarousel = grid.configuration.images
                if (
                    imagesCarousel &&
                    imagesCarousel.length > 0
                ) {

                    const newImagesStore = await Promise
                        .all((imagesCarousel as Array<string | File>)
                            .map(async (imageItem: string | File, imageIndex: number): Promise<string> => {
                                const result = await saveImage(imageItem, `${formToSend.title}_grid(${gridIndex + 1})_${grid.type}_${imageIndex + 1}`)
                                if (!result.success) {
                                    uploadErrors.push(`Grid ${gridIndex + 1} - imagem ${imageIndex + 1}: ${result.error}`)
                                    return ''
                                }
                                return result.url
                            }))

                    grid.configuration.images = newImagesStore
                }
            }
        }
        // ==========================================
        // RETORNO
        // ==========================================

        return {
            success: uploadErrors.length === 0,
            form: formToSend,
            errors: uploadErrors,
        }

    } catch (error) {

        const errorMessage =
            error instanceof Error
                ? error.message
                : 'Erro inesperado ao realizar upload das imagens'

        return {
            success: false,
            form,
            errors: [
                ...uploadErrors,
                errorMessage,
            ],
        }
    }
}


export const resizeImage = (file: File, targetWidth: number, targetHeight: number): Promise<File> => {
    return new Promise((resolve) => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')!
        const img = new Image()

        img.onload = () => {
            const { naturalWidth: width, naturalHeight: height } = img

            // Calcular o crop centralizado
            const sourceRatio = width / height
            const targetRatio = targetWidth / targetHeight

            let sourceWidth, sourceHeight, sourceX, sourceY

            if (sourceRatio > targetRatio) {
                // Imagem mais larga - cortar nas laterais
                sourceHeight = height
                sourceWidth = height * targetRatio
                sourceX = (width - sourceWidth) / 2
                sourceY = 0
            } else {
                // Imagem mais alta - cortar em cima e embaixo
                sourceWidth = width
                sourceHeight = width / targetRatio
                sourceX = 0
                sourceY = (height - sourceHeight) / 2
            }

            // Configurar canvas
            canvas.width = targetWidth
            canvas.height = targetHeight

            // Desenhar imagem redimensionada e cortada no centro
            ctx.drawImage(
                img,
                sourceX,
                sourceY,
                sourceWidth,
                sourceHeight,
                0,
                0,
                targetWidth,
                targetHeight
            )

            // Converter canvas para blob e depois para File
            canvas.toBlob(
                (blob) => {
                    if (blob) {
                        const resizedFile = new File([blob], file.name, {
                            type: file.type,
                            lastModified: Date.now(),
                        })
                        resolve(resizedFile)
                    }
                },
                file.type,
                0.9
            )
        }

        img.src = URL.createObjectURL(file)
    })
}

export const validateImage = (file: File): Promise<File | null> => {
    return new Promise((resolve) => {
        // Verificar tamanho do arquivo (máximo 2MB)
        const maxSizeInBytes = 2 * 1024 * 1024 // 2MB
        if (file.size > maxSizeInBytes) {
            Swal.fire({
                icon: 'warning',
                title: String(i18n.t('hospitality_publicity_create.validation.title')),
                text: String(i18n.t('hospitality_publicity_create.validation.image_size_error')),
            })
            resolve(null)
            return
        }

        // Verificar dimensões da imagem
        const img = new Image()
        img.onload = async () => {
            const width = img.naturalWidth
            const height = img.naturalHeight

            // Dimensões esperadas: aproximadamente 720x600 (tolerância de ±10%)
            const expectedWidth = 720
            const expectedHeight = 600
            const tolerance = 0.1 // 10%

            const minWidth = expectedWidth * (1 - tolerance)
            const maxWidth = expectedWidth * (1 + tolerance)
            const minHeight = expectedHeight * (1 - tolerance)
            const maxHeight = expectedHeight * (1 + tolerance)

            if (width < minWidth || width > maxWidth || height < minHeight || height > maxHeight) {
                // Perguntar se o usuário quer redimensionar
                const result = await Swal.fire({
                    icon: 'question',
                    title: String(i18n.t('hospitality_publicity_create.validation.title')),
                    html: `
                <p>${String(
                        i18n
                            .t('hospitality_publicity_create.validation.image_dimensions_error', {
                                current: `${width}x${height}`,
                                expected: `${expectedWidth}x${expectedHeight}`,
                            })
                            .replace('200x112', `${expectedWidth}x${expectedHeight}`)
                    )}</p>
                <p><strong>Deseja redimensionar a imagem automaticamente?</strong></p>
                <p><small>A imagem será cortada no centro para se ajustar às dimensões necessárias.</small></p>
              `,
                    showCancelButton: true,
                    confirmButtonText: 'Sim, redimensionar',
                    cancelButtonText: 'Não, escolher outra imagem',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                })

                if (result.isConfirmed) {
                    try {
                        const resizedFile = await resizeImage(file, expectedWidth, expectedHeight)
                        resolve(resizedFile)
                    } catch (error) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Ocorreu um erro ao redimensionar a imagem. Tente novamente.',
                        })
                        resolve(null)
                    }
                } else {
                    resolve(null)
                }
                return
            }

            resolve(file)
        }

        img.onerror = () => {
            Swal.fire({
                icon: 'warning',
                title: String(i18n.t('hospitality_publicity_create.validation.title')),
                text: String(i18n.t('hospitality_publicity_create.validation.image_invalid')),
            })
            resolve(null)
        }

        img.src = URL.createObjectURL(file)
    })
}